module.exports = {"id":"dp2_6l3q4","text":"Managing Digital Identity","instructions":"Adjusting privacy settings can help control digital identity exposure.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.6","questionType":"PickOne","random":false,"options":[{"id":"dp2_6l3q4-a1","text":"True","score":3.7},{"id":"dp2_6l3q4-a2","text":"Not sure","score":1.3},{"id":"dp2_6l3q4-a3","text":"False","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.6/l3q4.json
// module id = 1098
// module chunks = 41